import gql from "graphql-tag";

export const TelegramButtonFragment = gql`
  fragment TelegramButton on TelegramButton {
    id
    action
    isActive
  }
`;
